export default __webpack_public_path__ + "static/media/top_w576up992down_3.4e5fc286.png";